import FormattedMessage from 'I18n/components/FormattedMessage';
import formatName from 'I18n/utils/formatName';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { SuperAdminStatusTag } from '../components/common/SuperAdminStatusTag';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const buildApproverOption = ({
  approver,
  superAdminUserIds,
  approvedApproverUserIds,
  requesterUserId
}) => {
  var _approvedApproverUser;
  const searchableText = `${approver.firstName} ${approver.lastName} ${approver.email}`;
  const formattedName = formatName({
    firstName: approver.firstName,
    lastName: approver.lastName,
    email: approver.email
  });
  const isSuperAdmin = superAdminUserIds.has(approver.activeUserId);
  const isRequester = approver.activeUserId === requesterUserId;
  const isApproved = (_approvedApproverUser = approvedApproverUserIds === null || approvedApproverUserIds === void 0 ? void 0 : approvedApproverUserIds.includes(approver.activeUserId)) !== null && _approvedApproverUser !== void 0 ? _approvedApproverUser : false;
  const isDisabled = isApproved || isRequester;
  return {
    text: searchableText,
    buttonText: formattedName,
    value: approver.ownerId,
    help: approver.email,
    disabled: isDisabled,
    dropdownText: /*#__PURE__*/_jsx(Tooltip, {
      disabled: !isDisabled,
      title: isRequester ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.approverSelect.tooltipRequesterDisabled"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.approverSelect.tooltipApproverApproved"
      }),
      children: /*#__PURE__*/_jsxs(TFlex, {
        children: [formattedName, isSuperAdmin && /*#__PURE__*/_jsx(SuperAdminStatusTag, {})]
      })
    })
  };
};